import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultEntityGroupsExportFieldNames } from "~pages/EntityGroups/EntityGroupListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportEntityGroups = () => {
  const { sport = "", organizationId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultEntityGroupsExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/entityGroups/export`, {
        method: "POST",
        body,
      });
    },
  });
};
